import { Switch } from '@heidi/design-system/switch';
import { TypographyCaption, TypographyP2SemiBold } from '@heidi/design-system/typography';
import { showPageEditorInternalHtmlDebuggerAtom } from '@heidi/integrations/letters';
import { useAtom } from 'jotai';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  heading: {
    defaultMessage: 'Page editor',
    id: 'components.dev.pageEditor.heading',
  },
  debuggerLabel: {
    defaultMessage: 'Internal HTML debugger',
    id: 'components.dev.pageEditor.debuggerLabel',
  },
  debuggerDescription: {
    defaultMessage:
      'Shows the current Tiptap HTML, including internal page and section nodes.',
    id: 'components.dev.pageEditor.debuggerDescription',
  },
  toggleAriaLabel: {
    defaultMessage: 'Toggle PageEditor internal HTML debugger',
    id: 'components.dev.pageEditor.toggleAriaLabel',
  },
});

export const PageEditorDevSection = () => {
  const intl = useIntl();
  const [showDebugger, setShowDebugger] = useAtom(showPageEditorInternalHtmlDebuggerAtom);

  return (
    <section aria-labelledby="dev-tools-page-editor-heading">
      <TypographyP2SemiBold id="dev-tools-page-editor-heading" className="mb-2">
        {intl.formatMessage(messages.heading)}
      </TypographyP2SemiBold>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-0.5">
          <TypographyCaption className="text-text-secondary">
            {intl.formatMessage(messages.debuggerLabel)}
          </TypographyCaption>
          <TypographyCaption className="text-text-tertiary">
            {intl.formatMessage(messages.debuggerDescription)}
          </TypographyCaption>
        </div>
        <Switch
          size="sm"
          className="shrink-0"
          checked={showDebugger}
          onCheckedChange={setShowDebugger}
          aria-label={intl.formatMessage(messages.toggleAriaLabel)}
        />
      </div>
    </section>
  );
};
